import { render, staticRenderFns } from "./insurancePay.vue?vue&type=template&id=14ecc51e&scoped=true&"
import script from "./insurancePay.vue?vue&type=script&lang=js&"
export * from "./insurancePay.vue?vue&type=script&lang=js&"
import style0 from "./insurancePay.vue?vue&type=style&index=0&lang=less&"
import style1 from "./insurancePay.vue?vue&type=style&index=1&id=14ecc51e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ecc51e",
  null
  
)

export default component.exports